export default "__VITE_ASSET__BiCvXLBE__"